export enum CollabFileType {
  Workspace = 'workspace',
  Review = 'review'
}
